import gql from "graphql-tag";

export const allProjectsQuery = gql`
  query projects {
    projects {
      project_id
      name
      state
      tag
      date_shared
      buildings {
        building_id
        name
        address
        comments
      }
      equipments {
        equipment_id
        equipment_type
        date_calibrated
      }
      users {
        email
      }
    }
  }
`;

export const addProjectMutation = gql`
  mutation addProject(
    $name: String!
    $standard_id: String!
    $standard_name: String!
    $building_name: String!
    $floor_name: String!
  ) {
    addProject(
      name: $name
      standard_id: $standard_id
      standard_name: $standard_name
      building_name: $building_name
      floor_name: $floor_name
    ) {
      project_id
      name
      standard_id
      standard_name
      state
      tag
      buildings {
        building_id
        name
        floors {
          floor_id
          name
        }
      }
      equipments {
        equipment_id
        equipment_type
        date_calibrated
      }
    }
  }
`;

export const setProjectStateMutation = gql`
  mutation setState($project_id: ID!, $state: String!) {
    setState(project_id: $project_id, state: $state) {
      project_id
      state
    }
  }
`;

export const updateProjectMutation = gql`
  mutation updateProject(
    $project_id: ID!
    $name: String!
    $standard_id: String!
    $standard_name: String!
  ) {
    updateProject(
      project_id: $project_id
      name: $name
      standard_id: $standard_id
      standard_name: $standard_name
    ) {
      project_id
      name
      standard_id
      standard_name
    }
  }
`;

export const flagQuery = gql`
  query flag($name: String!) {
    flag(name: $name) {
      active
      name
    }
  }
`;

export const projectQuery = gql`
  query project($project_id: ID!) {
    project(project_id: $project_id) {
      buildings {
        building_id
        floors {
          floor_id
          plan_url
          is_pdf
          name
          comments
          rooms {
            room_id
            name
            room_type
            room_type_id
            room_info_comment
            room_image_url
            room_image_optimized_url
            measurement_points_comment
            longer_size_length
            distance_between_points_x
            distance_between_points_y
            measurement_height
            corners {
              room_corner_id
              x
              y
            }
            measurement_points {
              measurement_point_id
              x
              y
              location
              is_active
              is_accessible
              installer_comment
            }
            illumination_tests {
              illumination_test_id
              name
              test_requirements
              measurement_conditions
              average_illuminance
              illuminance_deviation
              uniformity
              is_compliant
              compliance_comment
              illumination_test_results {
                illumination_test_result_id
                measurement_point_id
                measured_lux
              }
              tester
              last_update
              equipments {
                equipment_type
                date_calibrated
              }
              required_ra
              required_rugl
              measured_ra
              measured_rugl
              required_flicker_percentage
              required_flicker_index
              measured_flicker_percentage
              measured_flicker_index
              include_flicker
              include_ra_rugl_maintenance
              maintenance_factor
              furniture
            }
            functional_tests {
              functional_test_id
              name
              test_requirements
              daylight_control_enabled
              daylight_control_disabled_comment
              daylight_zones_enabled
              daylight_zones_disabled_comment
              required_number_of_zones
              required_number_of_zones_unknown
              actual_number_of_zones
              motion_detectors_enabled
              motion_detectors_disabled_comment
              light_on_automatic
              light_off_delay
              is_compliant
              compliance_comment
              functional_test_results {
                functional_test_result_id
                question_identifier
                answer
                comment
              }
              tester
              last_update
              equipments {
                equipment_type
                date_calibrated
              }
            }
            distance_from_wall
          }
        }
        name
        comments
        address
      }
      name
      project_id
      standard_id
      standard_name
      state
      tag
      date_shared
      equipments {
        equipment_id
        equipment_type
        date_calibrated
      }
      users {
        email
      }
    }
  }
`;

export const addBuildingMutation = gql`
  mutation addBuilding(
    $name: String!
    $project_id: ID!
    $floor_name: String!
    $comments: String
    $address: String
  ) {
    addBuilding(
      name: $name
      project_id: $project_id
      floor_name: $floor_name
      comments: $comments
      address: $address
    ) {
      building_id
      name
      address
      comments
      floors {
        floor_id
        name
        plan_url
        is_pdf
      }
    }
  }
`;

export const updateBuildingMutation = gql`
  mutation updateBuilding(
    $building_id: ID!
    $name: String!
    $address: String
    $comments: String
  ) {
    updateBuilding(
      building_id: $building_id
      name: $name
      comments: $comments
      address: $address
    ) {
      building_id
      name
      comments
      address
    }
  }
`;

export const deleteBuildingMutation = gql`
  mutation deleteBuilding($building_id: ID!) {
    deleteBuilding(building_id: $building_id) {
      building_id
    }
  }
`;

export const addEquipmentMutation = gql`
  mutation addEquipment($project_id: ID!, $equipments: [EquipmentInput]) {
    addEquipment(project_id: $project_id, equipments: $equipments) {
      equipments {
        equipment_id
        equipment_type
        date_calibrated
      }
    }
  }
`;

export const addFloorMutation = gql`
  mutation addFloor($building_id: ID!, $name: String!) {
    addFloor(building_id: $building_id, name: $name) {
      floor_id
      name
    }
  }
`;

export const updateFloorMutation = gql`
  mutation updateFloor(
    $floor_id: ID!
    $name: String!
    $plan_url: String
    $is_pdf: Boolean
  ) {
    updateFloor(
      floor_id: $floor_id
      name: $name
      plan_url: $plan_url
      is_pdf: $is_pdf
    ) {
      floor_id
      name
      plan_url
      is_pdf
      comments
      rooms {
        room_id
        name
        room_type
        room_type_id
        room_info_comment
        room_image_url
        room_image_optimized_url
        measurement_points_comment
        longer_size_length
        distance_between_points_x
        distance_between_points_y
        measurement_height
        corners {
          room_corner_id
          x
          y
        }
        measurement_points {
          measurement_point_id
          x
          y
          location
          is_active
          is_accessible
          installer_comment
        }
        illumination_tests {
          illumination_test_id
          name
          test_requirements
          measurement_conditions
          average_illuminance
          illuminance_deviation
          uniformity
          is_compliant
          compliance_comment
          illumination_test_results {
            illumination_test_result_id
            measurement_point_id
            measured_lux
          }
          required_ra
          required_rugl
          measured_ra
          measured_rugl
          required_flicker_percentage
          required_flicker_index
          measured_flicker_percentage
          measured_flicker_index
          include_flicker
          include_ra_rugl_maintenance
          maintenance_factor
          furniture
        }
        functional_tests {
          functional_test_id
          name
          test_requirements
          daylight_control_enabled
          daylight_control_disabled_comment
          daylight_zones_enabled
          daylight_zones_disabled_comment
          required_number_of_zones
          required_number_of_zones_unknown
          actual_number_of_zones
          motion_detectors_enabled
          motion_detectors_disabled_comment
          light_on_automatic
          light_off_delay
          is_compliant
          compliance_comment
          functional_test_results {
            functional_test_result_id
            question_identifier
            answer
            comment
          }
        }
        distance_from_wall
      }
    }
  }
`;

export const deleteFloorMutation = gql`
  mutation deleteFloor($floor_id: ID!) {
    deleteFloor(floor_id: $floor_id) {
      floor_id
    }
  }
`;

export const addRoomMutation = gql`
  mutation addRoom(
    $floor_id: ID!
    $name: String!
    $room_type: String
    $room_type_id: Int
    $room_info_comment: String
    $room_image_url: String
    $measurement_points_comment: String
    $longer_size_length: Float
    $distance_between_points_x: Float
    $distance_between_points_y: Float
    $measurement_height: Float
    $distance_from_wall: Float
  ) {
    addRoom(
      floor_id: $floor_id
      name: $name
      room_type: $room_type
      room_type_id: $room_type_id
      room_info_comment: $room_info_comment
      room_image_url: $room_image_url
      measurement_points_comment: $measurement_points_comment
      longer_size_length: $longer_size_length
      distance_between_points_x: $distance_between_points_x
      distance_between_points_y: $distance_between_points_y
      measurement_height: $measurement_height
      distance_from_wall: $distance_from_wall
    ) {
      room_id
      name
      room_type
      room_type_id
      room_info_comment
      room_image_url
      measurement_points_comment
      longer_size_length
      distance_between_points_x
      distance_between_points_y
      measurement_height
      corners {
        room_corner_id
        x
        y
      }
      measurement_points {
        measurement_point_id
        x
        y
        location
        is_active
        is_accessible
        installer_comment
      }
      illumination_tests {
        illumination_test_id
        name
        test_requirements
        measurement_conditions
        average_illuminance
        illuminance_deviation
        uniformity
        is_compliant
        compliance_comment
        illumination_test_results {
          illumination_test_result_id
          measurement_point_id
          measured_lux
        }
        required_ra
        required_rugl
        measured_ra
        measured_rugl
        required_flicker_percentage
        required_flicker_index
        measured_flicker_percentage
        measured_flicker_index
        include_flicker
        include_ra_rugl_maintenance
        maintenance_factor
        furniture
      }
      distance_from_wall
    }
  }
`;

export const deleteRoomMutation = gql`
  mutation deleteRoom($room_id: ID!) {
    deleteRoom(room_id: $room_id) {
      room_id
    }
  }
`;

export const setRoomImageMutation = gql`
  mutation setRoomImage(
    $room_id: ID!
    $room_image_url: String
    $room_image_optimized_url: String
  ) {
    setRoomImage(
      room_id: $room_id
      room_image_url: $room_image_url
      room_image_optimized_url: $room_image_optimized_url
    ) {
      room_id
    }
  }
`;

export const setRoomCornersMutation = gql`
  mutation setRoomCorners($room_id: ID!, $corners: [RoomCornerInput]) {
    setRoomCorners(room_id: $room_id, corners: $corners) {
      room_id
      name
      room_type
      room_type_id
      room_info_comment
      room_image_url
      measurement_points_comment
      longer_size_length
      distance_between_points_x
      distance_between_points_y
      measurement_height
      corners {
        room_corner_id
        x
        y
      }
      measurement_points {
        measurement_point_id
        x
        y
        location
        is_active
        is_accessible
        installer_comment
      }
      distance_from_wall
    }
  }
`;

export const updateRoomMutation = gql`
  mutation updateRoom(
    $room_id: ID!
    $name: String!
    $room_type: String
    $room_type_id: Int
    $room_info_comment: String
    $room_image_url: String
    $room_image_optimized_url: String
    $measurement_points_comment: String
    $longer_size_length: Float
    $distance_between_points_x: Float
    $distance_between_points_y: Float
    $measurement_height: Float
    $distance_from_wall: Float
  ) {
    updateRoom(
      room_id: $room_id
      name: $name
      room_type: $room_type
      room_type_id: $room_type_id
      room_info_comment: $room_info_comment
      room_image_url: $room_image_url
      room_image_optimized_url: $room_image_optimized_url
      measurement_points_comment: $measurement_points_comment
      longer_size_length: $longer_size_length
      distance_between_points_x: $distance_between_points_x
      distance_between_points_y: $distance_between_points_y
      measurement_height: $measurement_height
      distance_from_wall: $distance_from_wall
    ) {
      room_id
      name
      room_type
      room_type_id
      room_info_comment
      room_image_url
      room_image_optimized_url
      measurement_points_comment
      longer_size_length
      distance_between_points_x
      distance_between_points_y
      measurement_height
      corners {
        room_corner_id
        x
        y
      }
      measurement_points {
        measurement_point_id
        x
        y
        location
        is_active
        is_accessible
        installer_comment
      }
      illumination_tests {
        illumination_test_id
        name
        test_requirements
        measurement_conditions
        average_illuminance
        illuminance_deviation
        uniformity
        is_compliant
        compliance_comment
        illumination_test_results {
          illumination_test_result_id
          measurement_point_id
          measured_lux
        }
        required_ra
        required_rugl
        measured_ra
        measured_rugl
        required_flicker_percentage
        required_flicker_index
        measured_flicker_percentage
        measured_flicker_index
        include_flicker
        include_ra_rugl_maintenance
        maintenance_factor
        furniture
      }
      functional_tests {
        functional_test_id
        name
        test_requirements
        daylight_control_enabled
        daylight_control_disabled_comment
        daylight_zones_enabled
        daylight_zones_disabled_comment
        required_number_of_zones
        required_number_of_zones_unknown
        actual_number_of_zones
        motion_detectors_enabled
        motion_detectors_disabled_comment
        light_on_automatic
        light_off_delay
        is_compliant
        compliance_comment
        functional_test_results {
          functional_test_result_id
          question_identifier
          answer
          comment
        }
      }
      distance_from_wall
    }
  }
`;

export const clearMeasurementPointsMutation = gql`
  mutation clearMeasurementPoints($room_id: ID!) {
    clearMeasurementPoints(room_id: $room_id) {
      room_id
    }
  }
`;

export const addMeasurementPointsMutation = gql`
  mutation addMeasurementPoints(
    $room_id: ID!
    $measurement_points: [MeasurementPointInput]
  ) {
    addMeasurementPoints(
      room_id: $room_id
      measurement_points: $measurement_points
    ) {
      room_id
    }
  }
`;

export const setIlluminationTestsMutation = gql`
  mutation setIlluminationTests(
    $room_id: ID!
    $tests: [IlluminationTestInput]
  ) {
    setIlluminationTests(room_id: $room_id, tests: $tests) {
      room_id
      name
    }
  }
`;

export const deleteIlluminationTestResultMutation = gql`
  mutation deleteIlluminationTestResult($illumination_test_result_id: ID!) {
    deleteIlluminationTestResult(
      illumination_test_result_id: $illumination_test_result_id
    ) {
      illumination_test_result_id
    }
  }
`;

export const setConditionsMutation = gql`
  mutation setConditions(
    $illumination_test_id: ID!
    $measurement_conditions: String
  ) {
    setConditions(
      illumination_test_id: $illumination_test_id
      measurement_conditions: $measurement_conditions
    ) {
      measurement_conditions
    }
  }
`;

export const setMeasuredRuglMutation = gql`
  mutation setMeasuredRugl($illumination_test_id: ID!, $measured_rugl: Int) {
    setMeasuredRugl(
      illumination_test_id: $illumination_test_id
      measured_rugl: $measured_rugl
    ) {
      measured_rugl
    }
  }
`;

export const setMeasuredRaMutation = gql`
  mutation setMeasuredRa($illumination_test_id: ID!, $measured_ra: Int) {
    setMeasuredRa(
      illumination_test_id: $illumination_test_id
      measured_ra: $measured_ra
    ) {
      measured_ra
    }
  }
`;

export const setMeasuredFlickerPercentageMutation = gql`
  mutation setMeasuredFlickerPercentage(
    $illumination_test_id: ID!
    $measured_flicker_percentage: Int
  ) {
    setMeasuredFlickerPercentage(
      illumination_test_id: $illumination_test_id
      measured_flicker_percentage: $measured_flicker_percentage
    ) {
      measured_flicker_percentage
    }
  }
`;

export const setMeasuredFlickerIndexMutation = gql`
  mutation setMeasuredFlickerIndex(
    $illumination_test_id: ID!
    $measured_flicker_index: Float
  ) {
    setMeasuredFlickerIndex(
      illumination_test_id: $illumination_test_id
      measured_flicker_index: $measured_flicker_index
    ) {
      measured_flicker_index
    }
  }
`;

export const setFurnitureQuestionMutation = gql`
  mutation setFurnitureQuestion(
    $illumination_test_id: ID!
    $furniture: String
  ) {
    setFurnitureQuestion(
      illumination_test_id: $illumination_test_id
      furniture: $furniture
    ) {
      furniture
    }
  }
`;

export const addIlluminationTestResultMutation = gql`
  mutation addIlluminationTestResult(
    $illumination_test_id: ID!
    $illumination_test_result: IlluminationTestResultInput
  ) {
    addIlluminationTestResult(
      illumination_test_id: $illumination_test_id
      illumination_test_result: $illumination_test_result
    ) {
      illumination_test_id
      name
      test_requirements
      measurement_conditions
      average_illuminance
      illuminance_deviation
      uniformity
      is_compliant
      compliance_comment
      illumination_test_results {
        illumination_test_result_id
        measurement_point_id
        measured_lux
      }
    }
  }
`;

export const updateIlluminationTestResultMutation = gql`
  mutation updateIlluminationTestResult(
    $illumination_test_result_id: ID!
    $illumination_test_id: ID!
    $illumination_test_result: IlluminationTestResultInput
  ) {
    updateIlluminationTestResult(
      illumination_test_result_id: $illumination_test_result_id
      illumination_test_id: $illumination_test_id
      illumination_test_result: $illumination_test_result
    ) {
      illumination_test_result_id
      measurement_point_id
      measured_lux
    }
  }
`;

export const setFunctionalTestsMutation = gql`
  mutation setFunctionalTests($room_id: ID!, $tests: [FunctionalTestInput]) {
    setFunctionalTests(room_id: $room_id, tests: $tests) {
      room_id
      name
      room_type
      room_type_id
      room_info_comment
      room_image_url
      room_image_optimized_url
      measurement_points_comment
      longer_size_length
      distance_between_points_y
      distance_between_points_x
      measurement_height
      corners {
        room_corner_id
        x
        y
      }
      measurement_points {
        measurement_point_id
        x
        y
        location
        is_active
        is_accessible
        installer_comment
      }
      illumination_tests {
        illumination_test_id
        name
        test_requirements
        measurement_conditions
        average_illuminance
        illuminance_deviation
        uniformity
        is_compliant
        compliance_comment
        illumination_test_results {
          illumination_test_result_id
          measurement_point_id
          measured_lux
        }
        required_ra
        required_rugl
        measured_ra
        measured_rugl
        required_flicker_percentage
        required_flicker_index
        measured_flicker_percentage
        measured_flicker_index
        include_flicker
        include_ra_rugl_maintenance
        maintenance_factor
        furniture
      }
      functional_tests {
        functional_test_id
        name
        test_requirements
        daylight_control_enabled
        daylight_control_disabled_comment
        daylight_zones_enabled
        daylight_zones_disabled_comment
        required_number_of_zones
        required_number_of_zones_unknown
        actual_number_of_zones
        motion_detectors_enabled
        motion_detectors_disabled_comment
        light_on_automatic
        light_off_delay
        is_compliant
        compliance_comment
        functional_test_results {
          functional_test_result_id
          question_identifier
          answer
          comment
        }
      }
      distance_from_wall
    }
  }
`;

export const setFunctionalTestZonesMutation = gql`
  mutation setFunctionalTestZones(
    $functional_test_id: ID!
    $actual_number_of_zones: Int
  ) {
    setFunctionalTestZones(
      functional_test_id: $functional_test_id
      actual_number_of_zones: $actual_number_of_zones
    ) {
      functional_test_id
      name
      test_requirements
      daylight_control_enabled
      daylight_control_disabled_comment
      daylight_zones_enabled
      daylight_zones_disabled_comment
      required_number_of_zones
      required_number_of_zones_unknown
      actual_number_of_zones
      motion_detectors_enabled
      motion_detectors_disabled_comment
      light_on_automatic
      light_off_delay
      is_compliant
      compliance_comment
      functional_test_results {
        functional_test_result_id
        question_identifier
        answer
        comment
      }
    }
  }
`;

export const setFunctionalTestResultsMutation = gql`
  mutation setFunctionalTestResults(
    $functional_test_id: ID!
    $results: [FunctionalTestResultInput]
  ) {
    setFunctionalTestResults(
      functional_test_id: $functional_test_id
      results: $results
    ) {
      functional_test_id
      name
      test_requirements
      daylight_control_enabled
      daylight_control_disabled_comment
      daylight_zones_enabled
      daylight_zones_disabled_comment
      required_number_of_zones
      required_number_of_zones_unknown
      actual_number_of_zones
      motion_detectors_enabled
      motion_detectors_disabled_comment
      light_on_automatic
      light_off_delay
      is_compliant
      compliance_comment
      functional_test_results {
        functional_test_result_id
        question_identifier
        answer
        comment
      }
    }
  }
`;

export const setIlluminationTestComplianceMutation = gql`
  mutation setIlluminationTestCompliance(
    $illumination_test_id: ID!
    $is_compliant: Boolean
    $compliance_comment: String
  ) {
    setIlluminationTestCompliance(
      illumination_test_id: $illumination_test_id
      is_compliant: $is_compliant
      compliance_comment: $compliance_comment
    ) {
      illumination_test_id
      name
      test_requirements
      measurement_conditions
      average_illuminance
      illuminance_deviation
      uniformity
      is_compliant
      compliance_comment
      illumination_test_results {
        illumination_test_result_id
        measurement_point_id
        measured_lux
      }
      required_ra
      required_rugl
      measured_ra
      measured_rugl
      required_flicker_percentage
      required_flicker_index
      measured_flicker_percentage
      measured_flicker_index
      include_flicker
      include_ra_rugl_maintenance
      maintenance_factor
      furniture
    }
  }
`;

export const setFunctionalTestComplianceMutation = gql`
  mutation setFunctionalTestCompliance(
    $functional_test_id: ID!
    $is_compliant: Boolean
    $compliance_comment: String
  ) {
    setFunctionalTestCompliance(
      functional_test_id: $functional_test_id
      is_compliant: $is_compliant
      compliance_comment: $compliance_comment
    ) {
      functional_test_id
      name
      test_requirements
      daylight_control_enabled
      daylight_control_disabled_comment
      daylight_zones_enabled
      daylight_zones_disabled_comment
      required_number_of_zones
      required_number_of_zones_unknown
      actual_number_of_zones
      motion_detectors_enabled
      motion_detectors_disabled_comment
      light_on_automatic
      light_off_delay
      is_compliant
      compliance_comment
      functional_test_results {
        functional_test_result_id
        question_identifier
        answer
        comment
      }
    }
  }
`;

export const shareAccessMutation = gql`
  mutation shareAccess($project_id: ID!, $emails: [String]) {
    shareAccess(project_id: $project_id, emails: $emails) {
      email
    }
  }
`;

export const generateSnapshotMutation = gql`
  mutation generateSnapshot($project_id: ID!, $version_time: String!) {
    generateSnapshot(project_id: $project_id, version_time: $version_time) {
      project_id
    }
  }
`;

export const revokeAccessMutation = gql`
  mutation revokeAccess($project_id: ID!, $email: String) {
    revokeAccess(project_id: $project_id, email: $email) {
      project_id
      email
    }
  }
`;

export const onSetState = gql`
  subscription OnSetState($project_id: ID!) {
    onSetState(project_id: $project_id) {
      state
    }
  }
`;

export const onRevokeAccess = gql`
  subscription OnRevokeAccess($project_id: ID!, $email: String) {
    onRevokeAccess(project_id: $project_id, email: $email) {
      email
    }
  }
`;

export const onSetFlag = gql`
  subscription OnSetFlag($name: String!) {
    onSetFlag(name: $name) {
      active
      name
      comment
      flag_id
    }
  }
`;

export const copySnapshotMutation = gql`
  mutation copySnapshot($snapshot_id: ID!) {
    copySnapshot(snapshot_id: $snapshot_id) {
      buildings {
        building_id
        floors {
          floor_id
          plan_url
          is_pdf
          name
          comments
          rooms {
            room_id
            name
            room_type
            room_type_id
            room_info_comment
            room_image_url
            room_image_optimized_url
            measurement_points_comment
            longer_size_length
            distance_between_points_x
            distance_between_points_y
            measurement_height
            corners {
              room_corner_id
              x
              y
            }
            measurement_points {
              measurement_point_id
              x
              y
              location
              is_active
              is_accessible
              installer_comment
            }
            illumination_tests {
              illumination_test_id
              name
              test_requirements
              measurement_conditions
              average_illuminance
              illuminance_deviation
              uniformity
              is_compliant
              compliance_comment
              illumination_test_results {
                illumination_test_result_id
                measurement_point_id
                measured_lux
              }
              tester
              required_ra
              required_rugl
              measured_ra
              measured_rugl
              required_flicker_percentage
              required_flicker_index
              measured_flicker_percentage
              measured_flicker_index
              include_flicker
              include_ra_rugl_maintenance
              maintenance_factor
              furniture
            }
            functional_tests {
              functional_test_id
              name
              test_requirements
              daylight_control_enabled
              daylight_control_disabled_comment
              daylight_zones_enabled
              daylight_zones_disabled_comment
              required_number_of_zones
              required_number_of_zones_unknown
              actual_number_of_zones
              motion_detectors_enabled
              motion_detectors_disabled_comment
              light_on_automatic
              light_off_delay
              is_compliant
              compliance_comment
              functional_test_results {
                functional_test_result_id
                question_identifier
                answer
                comment
              }
              tester
            }
            distance_from_wall
          }
        }
        name
        comments
        address
      }
      name
      project_id
      state
      tag
      standard_id
      standard_name
      equipments {
        equipment_id
        equipment_type
        date_calibrated
      }
      users {
        email
      }
    }
  }
`;

export const roomTypesQuery = gql`
  query room_types($standard_id: String) {
    room_types(standard_id: $standard_id) {
      top {
        group_name
        lux
        room_type
        room_type_id
        top
        type_id
        u0
        standard_id
        ra
        rugl
      }
      all {
        group_name
        lux
        room_type
        room_type_id
        type_id
        u0
        standard_id
        ra
        rugl
      }
    }
  }
`;

export const premiumQuery = gql`
  query premium {
    premium {
      active_subscription
      management_url
      account_id
      update_user_attributes
    }
  }
`;

export const generatePdfQuery = gql`
  query pdf($project: String) {
    pdf(project: $project) {
      data_url
    }
  }
`;

export const standardsQuery = gql`
  query standards {
    standards {
      standard_id
      standard_name
    }
  }
`;

export const missingEquipmentUsersQuery = gql`
  query missing_equipment_users($project_id: ID!) {
    missing_equipment_users(project_id: $project_id) {
      name
    }
  }
`;

export const fileQuery = gql`
  query file($type: String, $filename: String, $is_upload: Boolean) {
    file(type: $type, filename: $filename, is_upload: $is_upload) {
      url
    }
  }
`;

export const activeNewsQuery = gql`
  query activeNews {
    activeNews {
      news_id
      title
      content
      date_start
    }
  }
`;

export const optimizeImageQuery = gql`
  query optimizeImage($filename: String!) {
    optimizeImage(filename: $filename) {
      filename
    }
  }
`;
